import { render, staticRenderFns } from "./CardQrcode.vue?vue&type=template&id=810b35a6&"
import script from "./CardQrcode.vue?vue&type=script&lang=js&"
export * from "./CardQrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports